import { render, staticRenderFns } from "./_base-popover.vue?vue&type=template&id=1a5cabe8&scoped=true&"
import script from "./_base-popover.vue?vue&type=script&lang=js&"
export * from "./_base-popover.vue?vue&type=script&lang=js&"
import style0 from "./_base-popover.vue?vue&type=style&index=0&id=1a5cabe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5cabe8",
  null
  
)

export default component.exports